import Immutable from 'immutable';
import { diagnosticTabHasTask } from '../pco/cases/form/utils';

export const getTabsToRender = site => {
  const activitySettings = __ACTIVITY_SETTINGS__;

  const fullTabs = activitySettings => {
    const baseTasks = Immutable.List(['RAT', 'INSECT', 'OTHER_PESTS']);
    const annexTasks = Immutable.List(activitySettings.annexTasks).filter(
      t => diagnosticTabHasTask(t, site) || t.isActivated
    );

    if (activitySettings && activitySettings.annexTasks) {
      let tmpTasks = baseTasks;
      annexTasks.map(task => {
        if (task.name === 'Désinfection') {
          tmpTasks = tmpTasks.insert(2, task.taskType);
        } else {
          tmpTasks = tmpTasks.push(task.taskType);
        }
        return task;
      });

      return tmpTasks.toArray();
    }
    return baseTasks.toArray();
  };

  const tabs = fullTabs(activitySettings);
  return tabs.filter(t =>
    t === 'OTHER_PESTS'
      ? diagnosticTabHasTask(t, site) || activitySettings.otherPests.isActivated
      : true
  );
};

export const tabLabel = tab => {
  const activitySettings = __ACTIVITY_SETTINGS__;

  if (activitySettings && activitySettings.annexTasks) {
    const annexTasks = Immutable.List(activitySettings.annexTasks);
    const task = annexTasks.find(t => tab === t.taskType);

    if (task) {
      return task.name;
    }
  }

  switch (tab) {
    case 'RAT':
      return 'Dératisation';
    case 'INSECT':
      return 'Désinsectisation';
    case 'OTHER_PESTS':
      if (activitySettings && activitySettings.otherPests.name) {
        return activitySettings.otherPests.name;
      } else {
        return 'Autres Nuisibles';
      }
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/saas/common/tasks.js